import { GlobalService } from 'src/app/global.service';
import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ProductService } from '../product.service';
import { HttpService } from '../../http.service';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-product-table',
  templateUrl: './product-table.component.html',
  styleUrls: ['./product-table.component.scss']
})
export class ProductTableComponent {
  displayedColumns: string[] = ['id', 'name','short_name', 'code','product_group', 'quantity','fat', 'snf', 'base_price','gst','mrp', 'edit'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(public productService: ProductService, private http: HttpService, private global: GlobalService) {
    this.getProducts();
    this.productService.downloadProduct.subscribe((is_update_zone) => {
      console.log(is_update_zone);
      if (is_update_zone) {
        this.getProducts();
      }
    });
    this.global.set_master_page_title = 'Product';
  }

  showProductRegister() {
    this.productService.is_display_product_register_component = true;
  }

  hideProductRegister() {
    this.productService.is_display_product_register_component = false;
  }

  registerProduct() {
    this.showProductRegister();
    console.log('register zone');
    this.productService.productUpdate.emit(null);
    this.productService.set_product_data = null;
  }

  editProduct(product) {
    this.showProductRegister();
    console.log(product);
    this.productService.productUpdate.emit(product);
    this.productService.set_product_data = product;
  }

  getProducts() {
    this.http.getProduct().subscribe((data: Product[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Product>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }


}

export interface Product {
  id: number;
  group_id: number;
  unit_id: number;
  unit_name: string;
  quantity: number;
  gst_percent: number;
  mrp: number;
  name: string;
  short_name: string;
  code: string;
  description: string;
}
